export default "<section class=\"wrapper\">\r\n    <router-outlet></router-outlet>\r\n</section>\r\n"